import { fileFamily, fileLabel } from '../lib/fileKind';

/**
 * The extension as a tinted plate. Used instead of thumbnails on purpose: every content fetch is
 * an audited read, so rendering previews for a whole folder would flood the audit trail.
 */
export function FilePlate({
  filename,
  mime,
  size = 'md',
  className = '',
}: {
  filename: string | null | undefined;
  mime?: string | null;
  size?: 'md' | 'lg' | 'xl';
  className?: string;
}) {
  return (
    <span className={`gsl-plate ${className}`} data-family={fileFamily(filename, mime)} data-size={size} aria-hidden="true">
      {fileLabel(filename, mime)}
    </span>
  );
}
